module.exports = __webpack_public_path__ + "static/D365-project-management-0d649fb4e0dfa7f39b3bb4c3cf0873ca.png";